import React from 'react';
import Cabecalho from './cabecalho';

const cabecalhoContainer = props => {
  return <Cabecalho {...props} />;
};
export default cabecalhoContainer;
